import React from 'react';
import { RichText as RichTextRenderer } from 'prismic-reactjs';
import styled, { css } from 'styled-components';
import htmlSerializer, {
    plainHtmlSerializer,
} from '../../utils/htmlSerializer';
import { rem } from 'polished';

const Container = styled.div`
    ol,
    ul {
        padding-inline-start: ${rem(32)};
    }

    ol {
        list-style: auto;
    }

    li {
        line-height: 1.5;

        & + * {
            margin-top: ${rem(16)};
        }
    }

    ${({ space }) =>
        space &&
        css`
            > * {
                margin-top: ${space};
                margin-bottom: ${space};

                &:first-child {
                    margin-top: 0;
                }

                &:last-child {
                    margin-bottom: 0;
                }
            }
        `}
    ${({ underlineLinks, theme }) =>
        underlineLinks &&
        css`
            a {
                color: ${theme.colors.primary.main};
            }
        `}
    ${({ inline }) =>
        inline &&
        css`
            &,
            & > span {
                display: inline !important;
            }
        `}
`;

const RichText: typeof RichTextRenderer = ({
    inline,
    render,
    space,
    underlineLinks,
    plain,
}) => (
    <Container space={space} underlineLinks={underlineLinks} inline={inline}>
        <RichTextRenderer
            render={render}
            htmlSerializer={plain ? plainHtmlSerializer : htmlSerializer}
        />
    </Container>
);

export default RichText;
